import { render, staticRenderFns } from "./CartaoDeDado.vue?vue&type=template&id=473f5c48&scoped=true"
import script from "./CartaoDeDado.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeDado.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeDado.vue?vue&type=style&index=0&id=473f5c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f5c48",
  null
  
)

export default component.exports